export default {
  title: "Contacts overview",
  noRecords: "No contacts found",
}
